const config = {
  // Source List
  source: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      }
    ],
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: 'Select User Groups',
    rowSelectionConfig: {
      selectItemOnSingleClick: false,
      selectItemOnDoubleClick: false,
      highlightRow: true,
      multiRow: true,
      toggleRow: false
    }
  },
  // Destination List
  destination: {
    // General
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => record.group.name
      }
    ],
    // Filtering
    sorter: {
      field: 'group__name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['group__name'],
        searchValue: ''
      }
    },
    title: 'Assigned to User',
    rowSelectionConfig: {
      selectItemOnSingleClick: false,
      selectItemOnDoubleClick: false,
      highlightRow: true,
      multiRow: true,
      toggleRow: true
    }
  }
};

export default config;
